export default __webpack_public_path__ + "static/media/lgn-lg-1.33743406.webp";